var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('row',{staticClass:"pa-4",attrs:{"item1":_vm.item,"item2":_vm.item,"settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }